function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.5 3H2.5H10.5",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.25 3.00006C10.25 2.58584 9.91421 2.25006 9.5 2.25006C9.08579 2.25006 8.75 2.58584 8.75 3.00006H10.25ZM3.25 3.00006C3.25 2.58584 2.91421 2.25006 2.5 2.25006C2.08579 2.25006 1.75 2.58584 1.75 3.00006H3.25ZM3.25 3.00012C3.25 3.41434 3.58579 3.75012 4 3.75012C4.41422 3.75012 4.75 3.41434 4.75 3.00012H3.25ZM7.25 3.00012C7.25 3.41434 7.58579 3.75012 8 3.75012C8.41421 3.75012 8.75 3.41434 8.75 3.00012H7.25ZM8.75 3.00006V10.0001H10.25V3.00006H8.75ZM8.75 10.0001C8.75 10.1381 8.63807 10.2501 8.5 10.2501V11.7501C9.4665 11.7501 10.25 10.9666 10.25 10.0001H8.75ZM8.5 10.2501H3.5V11.7501H8.5V10.2501ZM3.5 10.2501C3.36193 10.2501 3.25 10.1381 3.25 10.0001H1.75C1.75 10.9666 2.5335 11.7501 3.5 11.7501V10.2501ZM3.25 10.0001V3.00006H1.75V10.0001H3.25ZM4.75 3.00012V2.00012H3.25V3.00012H4.75ZM4.75 2.00012C4.75 1.86205 4.86193 1.75012 5 1.75012V0.250122C4.0335 0.250122 3.25 1.03362 3.25 2.00012H4.75ZM5 1.75012H7V0.250122H5V1.75012ZM7 1.75012C7.13807 1.75012 7.25 1.86205 7.25 2.00012H8.75C8.75 1.03362 7.9665 0.250122 7 0.250122V1.75012ZM7.25 2.00012V3.00012H8.75V2.00012H7.25Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M5 5.50012V8.50012",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M7 5.50012V8.50012",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgTrashWhiteSmall = function SvgTrashWhiteSmall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTrashWhiteSmall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trash-white-small.f9fa47dd.svg";
export { ForwardRef as ReactComponent };